module.exports = __webpack_public_path__ + "static/img/home_content_3.6d60245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_content_3.png
// module id = et17
// module chunks = 1